module.exports = __webpack_public_path__ + "img/logo3.a84b7a96.png";